import { createTRPCRouter, publicProcedure } from "../trpc";
import { expenseRouter } from "./expense";
import { incomeRouter } from "./income";
import { otherRouter } from "./other";
import { purposesRouter } from "./purpose";
import { transactionRouter } from "./transaction";
import { userRouter } from "./user";

export const MainRouter = createTRPCRouter({
    sayHello: publicProcedure.query(() => {
        return "Hello"
    }),

    user: userRouter,
    income: incomeRouter,
    expense: expenseRouter,
    other: otherRouter,
    purposes: purposesRouter,
    transaction: transactionRouter,
})

export type tRPC_Router = typeof MainRouter;
